import React, {useState} from 'react';
import { RecipiesPopUpProps } from '../../types/recipes';
import PopUp from '../../components/PopUp';
import {TextInput, Select } from '@mantine/core';
import {ReactComponent as DropdownIcon } from '../../assets/icons/Dropdown.svg'

 
const RecipesPopUp = ({opened, close, title, onSave, options, sorterInfo, defName}:RecipiesPopUpProps)=>{
    const [dropdownValue, setDropdownValue] = useState<string | null>(null);
    const [inputValue, setInputValue] = useState(defName||'');
    const [inputError, setInputError] = useState('');

    const handleInputChange = (value:string) => {
        setInputValue(value);

        if (!/^[a-zA-Z0-9]*$/.test(value)) {
            setInputError('Only numeric characters allowed.');
        } else {
            setInputError('');
        }
    };

    const onSaveClose = () =>{
        onSave(Number(dropdownValue || "-1"),inputValue, sorterInfo?.num_hoppers||-1, sorterInfo?.sorter_color_model_id||-1, sorterInfo?.sorter_recycling_model_id||-1, sorterInfo?.sorter_reuse_model_id||-1 )
        close()
    }

    return(
        <PopUp opened={opened} close={close} title={title} onSave={onSaveClose} >
            {title !== "Duplicate" && <Select label={"Sorter"} data={options} value={dropdownValue} onChange={setDropdownValue} rightSection={<DropdownIcon  width={19} height={19}></DropdownIcon >}/>}
            <TextInput label="Name" value={inputValue} onChange={(event) => handleInputChange(event.currentTarget.value)} error={inputError}  />      
        </PopUp>    
    );
    
}

export default RecipesPopUp